import React, { memo, Suspense, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { DefaultCustomTemplate } from "../template"

export const Footer = memo(() => {
    const { i18n } = useTranslation()

    const currentLanguage = useRef<string>()
    const [views, setViews] = useState<React.JSX.Element | undefined>()

    useEffect(() => {
        if (!currentLanguage.current || currentLanguage.current != i18n.language) {
            currentLanguage.current = i18n.language
            DefaultCustomTemplate(setViews, "Footer")
        }
    }, [i18n.language])

    return (
        <Suspense fallback={<div>Loading ...</div>}>
            <footer>{views}</footer>
        </Suspense>
    )
})
Footer.displayName = "Footer"
